import axios, { Axios } from "axios";
import { language } from "../../../helpers/Utils";

export const HTTP_CODE = {
  ACCEPTED: 202,
  BADREQUEST: 400,
  CONFLICT: 409,
  CREATED: 201,
  OK: 200
};

const defaultOptions = {
  headers: {
    "X-Authorization": "Bearer " + localStorage.getItem("token"),
    "post-id": localStorage.getItem("post_id") ?? "",
    "session-id": localStorage.getItem("session_id") ?? "",
    "service-instance-id": localStorage.getItem("org_instance_id") ?? "",
    region: "uk",
    organization: "eln",
    "Content-Type": "application/json",
    "Accept-Language": language()
  }
};


export const STORE_ORDER_NOTIFICATION = "Store/Order/NewOrderNotifiction/"
export function getStoreOrderNotification(id: any) {
  return axios.get(STORE_ORDER_NOTIFICATION + "?order=" + id)
}

export const ORG_TREE_NODE_CONFIG_UPDATE = "/Org/Tree/NodeConfig/Update/"
export function patchOrgTreeNodeConfigUpdate(id: any, data: any) {
  return axios.patch(ORG_TREE_NODE_CONFIG_UPDATE + id + "/", data);
}

export const ORG_TREE_NODE_ADDRESS_LIST = "/Org/Tree/NodeAddress/List/"

export function getOrgTreeNodeaddressList(id: any) {
  return axios.get(ORG_TREE_NODE_ADDRESS_LIST + "?node_id=" + id);
}

export const ORG_POLICY_ROLE_POLICY_LIST = "Org/Policy/RolePolicy/List/"
export function getOrgPolicyRolePolicyList(id: any) {
  return axios.get(ORG_POLICY_ROLE_POLICY_LIST + "?role_id=" + id)
}


export const ORG_TREE_NODE_ADDRESS_CREATE = "/Org/Tree/NodeAddress/Create/"
export function postOrgTreeNodeAddressCreate(id: any, data: any) {
  return axios.post(ORG_TREE_NODE_ADDRESS_CREATE + id, data);
}

export const ORG_TREE_NODE_ADDRESS_UPDATE = "/Org/Tree/NodeAddress/Update/"

export function patchOrgTreeNodeAddressUpdate(id: any, data: any) {
  return axios.patch(ORG_TREE_NODE_ADDRESS_UPDATE + id, data);
}



export const ORG_TREE_NODE_ADDRESS_GET = "/Org/Tree/NodeAddress/Get/"

export function getOrgTreeNodeaddressGet(id: any) {
  return axios.get(ORG_TREE_NODE_ADDRESS_GET + id);
}

// service area api

export const ORG_SERVICE_AREA_LIST = "Org/Tree/NodeServiceArea/List/";

export function getOrgServiceAreaList() {
  return axios.get(ORG_SERVICE_AREA_LIST);
}

export const ORG_SERVICE_AREA_ADD = "Org/Tree/NodeServiceArea/Add/";
export function addOrgServiceArea(values: any) {
  return axios.post(ORG_SERVICE_AREA_ADD, values);
}

export const ORG_SERVICE_AREA_DELETE = "Org/Tree/NodeServiceArea/Remove/";
export function deleteOrgServiceArea(id: any) {
  return axios.delete(ORG_SERVICE_AREA_DELETE + id + "/");
}

export const ORG_SERVICE_AREA_GET = "Org/Tree/NodeServiceArea/Get/";
export function getOrgServiceArea(id: any) {
  return axios.get(ORG_SERVICE_AREA_GET + id + "/");
}


export const ORG_SERVICE_AREA_UPDATE = "Org/Tree/NodeServiceArea/Update/";
export function updateOrgServiceArea(id: any, value: any) {
  return axios.patch(ORG_SERVICE_AREA_UPDATE + id + "/", value)
}



export const GET_COUNTRY = "/county/?country-id=";
export const GET_STATE = "/state/?page_size=1000&country-id=";
export const GET_CITY = "/city/?page_size=1000&country-id=";
export const GET_COUNTRY_BY_PAGE = "/country/?page_size=1000";
export const GET_CURRENCY_TIMEZONE = "/Org/CurrencyTimezone/Add";

export function getCountryList() {
  return axios.get(GET_COUNTRY_BY_PAGE);
}

export function getCountyList(id: any) {
  return axios.get(GET_COUNTRY + id);
}

export function getStateList(id: any) {
  return axios.get(GET_STATE + id);
}
export function getCityList(countryId: any, stateId: any) {
  return axios.get(
    GET_CITY + countryId + "&state-id=" + stateId
  );
}

export function getCurrencyTimeZoneList(id: string) {
  return axios.get(`${GET_CURRENCY_TIMEZONE}?country-code=${id}`);
}
// nodedetails Contact

export const ORG_TREE_NODE_CONTACT_ADD = "/Org/Tree/Node/Contact/Add"
export const ORG_TREE_NODESETTING_REMOVE = "/Org/Tree/NodeSetting/Remove/"
export const ORG_TREE_NODESETTING_EDIT = "/Org/Tree/NodeSetting/Edit/"

export function postOrgTreeNodeContactAdd(data: any) {
  return axios.post(ORG_TREE_NODE_CONTACT_ADD, data);
}
export function deleteOrgTreeNodeSettingRemove(id: any) {
  return axios.delete(ORG_TREE_NODESETTING_REMOVE + id + "/");
}
export function postOrgTreeNodeSettingEdit(data: any, id: any) {
  return axios.post(ORG_TREE_NODESETTING_EDIT + id + "/", data);
}

export const ORG_CONTACTS_CONTACT_TYPES_LIST = "/Org/Contacts/ContactTypes/List/"

export function getOrgContactsContactTypesList() {
  return axios.get(ORG_CONTACTS_CONTACT_TYPES_LIST)
}

export const ORG_TREE_NODE_SETTING_SOCIAL_MEDIA_CONTANCT_LIST = "Org/Tree/NodeSetting/SocialMedias/Contact/List";

export function getOrgTreeNodeSettingSocialMediaList(id: any, page: any) {
  return axios.get(ORG_TREE_NODE_SETTING_SOCIAL_MEDIA_CONTANCT_LIST + "?node_id=" + id + "&page=" + page);
}
export const ORG_TREE_NODE_SETTING_SOCIAL_MEDIA_LIST = "Org/Tree/NodeSetting/SocialMedias/List"

export function getOrgTreeNodeSettingSocial(id: any, page: any) {
  return axios.get(ORG_TREE_NODE_SETTING_SOCIAL_MEDIA_LIST + "?node_id=" + id + "&page=" + page);
}

// Get 
export const ORG_TREE_NODE_CONFIG_GET = "/Org/Tree/NodeConfig/Get/";

export function getOrgTreeNodeConfigGet(id: any) {
  return axios.get(ORG_TREE_NODE_CONFIG_GET + id + "/");
}

export const ORG_CONTACTS_SOCIAL_MEDIA_LIST = "/Org/Contacts/SocialMedia/List/"

export function getOrgContactsSocialMediaList() {
  return axios.get(ORG_CONTACTS_SOCIAL_MEDIA_LIST);
}

export const ORG_TREE_NODE_SOCIL_MEDIA_ADD = "/Org/Tree/Node/SocialMedia/Add"

export function postOrgTreeNodeSocilMediaAdd(data: any) {
  return axios.post(ORG_TREE_NODE_SOCIL_MEDIA_ADD, data);
}


export const ORG_TREE_NODE_SETTING_UPDATE = "/Org/Tree/NodeSetting/Update"


export function patchOrgTreeNodeSettingUpdate(data: any) {
  return axios.patch(ORG_TREE_NODE_SETTING_UPDATE, data);
}


export const ORG_TREE_NODE_SETTING_ADD = "/Org/Tree/NodeSetting/Add";
export function postOrgTreeNodeSettingAdd(data: any) {
  return axios.post(ORG_TREE_NODE_SETTING_ADD, data);
}
export const ORG_TREE_NODE_SETTING_LIST = "/Org/Tree/NodeSetting/List"

export function getOrgTreeNodeSettingList() {
  return axios.get(ORG_TREE_NODE_SETTING_LIST);
}

export const ORG_TREE_LEVEL_VARIANT_LIST = "Org/Tree/LevelVariant/List";
export function getOrgTreeLevelVarientList(id: any) {
  return axios.get(ORG_TREE_LEVEL_VARIANT_LIST + "?node_id=" + id);
}

// node list
export const ORG_TREE_NODE_LIST = "Org/Tree/Node/List";
export function getOrgTreeNodeList() {
  return axios.get(ORG_TREE_NODE_LIST);
}

// node remove Api 
export const ORG_TREE_NODE_REMOVE = "/Org/Tree/Node/Remove/"
export function deleteOrgTreeNodeRemove(id: any) {
  return axios.delete(ORG_TREE_NODE_REMOVE + id);
}

export const ORG_TREE_LIST_LEVEL_VARIANT_UNIQUE_TYPES = "Org/Tree/ListLevelVariantUniqueTypes";
export function getOrgTreeListVarientUniqueTypes() {
  return axios.get(ORG_TREE_LIST_LEVEL_VARIANT_UNIQUE_TYPES);
}


export const ORG_TREE_NODE_PATCH = "/Org/Tree/Node/Update/";
export function patchOrgTreeNodePatch(id: any, data: any) {
  return axios.patch(ORG_TREE_NODE_PATCH + id, data);
}
// add-on remove 
export const STORE_PRODUCT_ADDON_REMOVE = "Store/Product/Addon/Remove/"

// ENTITY node Add
// export const ENTITY_NODE_ADD = "/Entity/Node/Add";
export const ENTITY_NODE_ADD = "/Org/Tree/Node/Add";
export function postEntityNodeAdd(data: any) {
  return axios.post(ENTITY_NODE_ADD, data);
}

export const ENTITY_CHILDREN_ADD = "/Org/Tree/Branch/Add";
export function postEntityChildrenAdd(data: any) {
  return axios.post(ENTITY_CHILDREN_ADD, data)
}

export const ORG_INSTANCE_MAPLIST = "Org/InstanceVariantMap/List";
export function getOrgInstanceMap(id: any) {
  return axios.get(ORG_INSTANCE_MAPLIST + "?org_instance=" + id)
}
// normal user popup
export const ORG_LIST_BY_INSTANCE = "/Org/ServiceVariantType/ListByInstance";
export function getListByInstance(id: any) {
  return axios.get(ORG_LIST_BY_INSTANCE + "?org_instance=" + id)
}

// Branch List 
export const ORG_BRANCH_LIST = "Org/Services/ServiceInstances/List/";
export function getBranchList(id: any, data: any) {
  return axios.get(ORG_BRANCH_LIST + "?service_id=" + id + "&type=" + data)
}

export const ORG_SERVICE_SERVICE_INSTANCES_LIST_WITH_NODE = "Org/Services/ServiceInstances/ListWithNode/";
export function getOrgServiceInstancesListWithNode() {
  return axios.get(ORG_SERVICE_SERVICE_INSTANCES_LIST_WITH_NODE);
}

export const ENTITY_EVENT_EXPENSE_RECORD_REMOVE = "/Entity/Event/Expense/Record/Remove/"

export function deleteEntityEventExpenseRecordRemove(id: any) {
  return axios.delete(
    ENTITY_EVENT_EXPENSE_RECORD_REMOVE + id
  );
}

export const ENTITY_EVENT_EXPENSE_RECORD_GET = "/Entity/Event/Expense/Record/Get/"
export function getEntityEventExpenseRecordGet(id: any) {
  return axios.get(
    ENTITY_EVENT_EXPENSE_RECORD_GET + id
  );
}



// currency list Api 
export const CURRENCY_LIST = "currency/";
export function getCurrencyList() {
  return axios.get(CURRENCY_LIST);
}
// TimeZone list Api 
export const TIMEZONE_LIST = "timezone/";
export function getTimeZoneList() {
  return axios.get(TIMEZONE_LIST);
}

export const ORG_SERVICE_VARIANT_LIST = "Org/ServiceVariant/List";
export function getOrgServiceVariantList() {
  return axios.get(ORG_SERVICE_VARIANT_LIST);
}

export const ORG_OUT_SERVICE_VARIANT_LIST = "Org/Services/Variants/List/";
export function getOrgOutServiceVariantList() {
  return axios.get(ORG_OUT_SERVICE_VARIANT_LIST);
}

export const ORG_SERVICE_VARIANT_ADD = "Org/InstanceVariantMap/Add";
export function postServicevarientAdd(data: any) {
  return axios.post(ORG_SERVICE_VARIANT_ADD, data);
}

export const ORG_SERVICE_VARIANT_UPDATE = "Org/InstanceVariantMap/Update/";
export function postServicevarientUpdate(data: any) {
  return axios.patch(ORG_SERVICE_VARIANT_UPDATE, data);
}


// Entity service instance
// export const ENTITY_SERVICE_INSTANCE_ADD = "Entity/ServiceInstance/Add";
export const ENTITY_SERVICE_INSTANCE_ADD = "Org/Services/ServiceInstances/Instance/Add";
export function postEntityServiceInstanceAdd(data: any) {
  return axios.post(ENTITY_SERVICE_INSTANCE_ADD, data);
}

// client add 
export const ENTITY_CLIENT_ADD = "Org/Tree/Client/Add"
export function postEntityClientAdd(data: any) {
  return axios.post(ENTITY_CLIENT_ADD, data);
}




export const ORG_SERVICES_SERVICE_INSTANCE_UPDATE = "Org/Services/ServiceInstances/Update/";
export function patchSevicesServiceInstancesUpdate(id: any, data: any) {
  return axios.patch(ORG_SERVICES_SERVICE_INSTANCE_UPDATE + id + "/", data);
}
export const ORG_SERVICES_SERVICE_INSTANCE_REMOVE = "Org/Services/ServiceInstances/Remove/";
export function deleteSevicesServiceInstancesRemove(id: any) {
  return axios.delete(ORG_SERVICES_SERVICE_INSTANCE_REMOVE + id + "/");
}

export const ORG_SERVICES_SERVICE_INSTANCES_GET = "Org/ServiceInstances/Get/";
export function getSevicesServiceInstancesGet(id: any) {
  return axios.get(ORG_SERVICES_SERVICE_INSTANCES_GET + id + "/");
}

export const ORG_SERVICES_SERVICE_INSTANCES_IMAGES_REMOVE = "Org/Services/ServiceInstances/Images/Remove/";
export function deleteOrgServicesInstancesImagesRemove(id: any) {
  return axios.delete(ORG_SERVICES_SERVICE_INSTANCES_IMAGES_REMOVE + id + "/");
}

export const ORG_SMS_GATEWAY_LIST = "/Org/SmsGateways/List";
export function getSmsGatewayList() {
  return axios.get(ORG_SMS_GATEWAY_LIST);
}

export const ORG_EMAIL_TESTING = "Org/Test/Email/";
export function emailTesting(data: any) {
  return axios.post(ORG_EMAIL_TESTING, data);
}

//------------UI Common Template Api Start-----------//

//======Section API Call============//
//section List
export const API_SECTIONLIST = "Entity/Widget/List"
export function sectionsListApiCall(id: any, data: any) {
  return axios.get(API_SECTIONLIST + "/" + id + "?identifier=" + data);
}

//section Get
export const API_SECTION_GET = "Entity/Widget/Get/"
export function sectionsAddGetApiCall(id: any) {
  return axios.get(API_SECTION_GET + id);
}

//section Add
export const API_SECTIONADD = "Entity/SubSections/Create"
export function sectionsAddApiCall(data: any) {
  return axios.post(API_SECTIONADD, data);
}

//section update
export const API_SECTION_UPDATE = "Entity/Widget/Update/"
export function sectionsUpdateApiCall(data: any, id: any) {
  return axios.patch(API_SECTION_UPDATE + id, data);
}

//section Delete
export const API_SECTION_REMOVE = "Entity/Widget/Remove/"
export function sectionDeleteApiCall(id: any) {
  return axios.delete(API_SECTION_REMOVE + id);
}


//======SubSection API Call============//

//SubSection Delete
export const API_SUB_SECTION_REMOVE = "Entity/SubSections/Remove"
export function subSectionDeleteApiCall(id: any) {
  return axios.delete(API_SUB_SECTION_REMOVE + "/" + id);
}

//SubSection List
export const API_SUB_SECTION_LIST = "/Entity/SubSections/List/"
export function subSectionsListApiCall(id: any) {
  return axios.get(API_SUB_SECTION_LIST + id);
}



//SubSection Add
export const API_SUB_SECTION_ADD = "Entity/SubSections/Add"
export function subSectionsAddApiCall(data: any) {
  return axios.post(API_SUB_SECTION_ADD, data);
}


//SubSection AddImage API

export const API_SUB_SECTION_IMAGE_ADD = "Entity/SubSections/AddImage/"
export function subSectionsImageAddApiCall(id: any, data: any) {
  return axios.post(API_SUB_SECTION_IMAGE_ADD + id, data);
}

export const API_SUB_SECTION_IMAGE_DELETE = "Entity/SubSections/DeleteImage/"
export function subSectionsImageDeleteApiCall(id: any, data: any) {
  return axios.post(API_SUB_SECTION_IMAGE_DELETE + id, data);
}


//section Get
export const API_SUB_SECTION_GET = "Entity/SubSections/Get/"
export function subSectionsAddGetApiCall(id: any) {
  return axios.get(API_SUB_SECTION_GET + id);
}

//subsection update API
export const API_SUB_SECTION_UPDATE = "Entity/SubSections/Update/"
export function subSectionsUpdateApiCall(data: any, id: any) {
  return axios.patch(API_SUB_SECTION_UPDATE + id, data);
}
//------------UI Common Template Api ENd-----------//


// wallet Api
export const ENTITY_WALLET_LIST = "Org/Wallet/List/"
export function getEntityWalletList(id: any) {
  return axios.get(ENTITY_WALLET_LIST + "?service_instance=" + id);
}

export const ENTITY_WALLET_REMOVE = "Org/Wallet/Remove"
export function deleteEntityWalletList(id: any) {
  return axios.delete(ENTITY_WALLET_REMOVE + "/" + id + "/");
}

export const ENTITY_WALLET_GET = "Org/Wallet/Get/"
export function getEntityWalletGet(id: any) {
  return axios.get(ENTITY_WALLET_GET + id + "/");
}

export const WALLET_VARIANTS_LIST = "Org/WalletVariant/List/"
export function getWalletVariantList() {
  return axios.get(WALLET_VARIANTS_LIST + "?page_size=100");
}

export const ENTITY_WALLET_UPDATE = "Org/Wallet/Update/"
export function patchEntityWalletUpdate(id: any, data: any) {
  return axios.patch(ENTITY_WALLET_UPDATE + id + "/", data);
}


export const ENTITY_WALLET_ADD = "Org/Wallet/Add/"
export function postEntityWalletAdd(data: any) {
  return axios.post(ENTITY_WALLET_ADD, data);
}

// Add User API 
export const GET_USER_LIST = "/Org/User/ListFetch";

export const ORG_USER_NODE_GET = "Org/User/Nodes/Get/";
export function getOrgUserNode(id: string) {
  return axios.get(ORG_USER_NODE_GET + id + "/");
}

export const ORG_USER_NODE_LIST = "Org/Institute/User/List/";
export function getOrgUserNodeList() {
  return axios.get(ORG_USER_NODE_LIST);
}

export const ORG_INST_PEOPLE_STATUS_LIST = "Org/user/Nodes/status-choices/";
export function getOrgInstPeopleStatusList() {
  return axios.get(ORG_INST_PEOPLE_STATUS_LIST);
}

export const ORG_USER_NODE_UPDATE = "Org/User/Nodes/add_user_to_node/Add/";
export function updateOrgUserNode(id: any, value: any) {
  return axios.post(ORG_USER_NODE_UPDATE, value)
}

export const ORG_EXIST_USERE_ADD = "Org/User/Nodes/UserNode/Add/";
export function addOrgUserOrgExistUser(values: any) {
  return axios.post(ORG_EXIST_USERE_ADD, values);
}

export const ORG_USER_PRI_SIGNUP = "Org/User/ins_private_signup/";
export function addOrgUserPrivateSignup(values: any) {
  return axios.post(ORG_USER_PRI_SIGNUP, values);
}

export const ORG_USER_NODE_DELETE = "Org/User/Nodes/Remove/";
export function deleteOrgUserNode(id: any) {
  return axios.delete(ORG_USER_NODE_DELETE + id + "/");
}

export const ORG_USER_NODE_USER_STATUS_UPDATE = "Org/User/Nodes/UserStatus/Update/";
export function updateOrgUserNodeUserStatus(id: any, value: any) {
  return axios.patch(ORG_USER_NODE_USER_STATUS_UPDATE + id + "/", value)
}

export const ORG_EMPLOYEE_LIST = "Org/User/Employee/PrivateSignup/";
export function addUserSignup(values: any) {
  return axios.post(ORG_EMPLOYEE_LIST, values);
}


// App Setting API 

// APP Setting API

export const ORG_APP_MANAGER_REMOVE = "Org/AppManager/Remove/"

export function deleteOrgAppManagerRemove(id: any) {
  return axios.delete(
    ORG_APP_MANAGER_REMOVE + id
  );
}
export const ORG_APP_MANAGER_LIST = "Org/AppManager/List/?service_instance="

export function getOrgAppManagerList(id: any) {
  return axios.get(
    ORG_APP_MANAGER_LIST + id
  );
}

export const ORG_APP_MANAGER_GET = "Org/AppManager/get/"
export function getOrgAppManagerGet(id: any) {
  return axios.get(
    ORG_APP_MANAGER_GET + id
  );
}

export const ORG_APP_MANAGER_ADD = "Org/AppManager/Add/"

export function postOrgAppManagerAdd(data: any) {
  return axios.post(
    ORG_APP_MANAGER_ADD,
    data
  );
}

export const ORG_APP_MANAGER_UPDATE = "/Org/AppManager/Update/"

export function patchOrgAppManagerUpdate(id: any, data: any) {
  return axios.patch(
    ORG_APP_MANAGER_UPDATE + id,
    data
  );
}

// app details
export const ORG_LIST_PLAT_FORM = "Org/ListPlatform"
export function getOrgListPlatForm() {
  return axios.get(ORG_LIST_PLAT_FORM)
}

// store-setting

export const ORG_STORE_SETTING_LIST = "Store/StoreSettings/List/"
export function getOrgStoreSettingList() {
  return axios.get(ORG_STORE_SETTING_LIST)
}
export const ORG_STORE_SETTING_ADD = "Store/StoreSettings/Add/"
export function postStoreSettingRoleAdd(data: any) {
  return axios.post(ORG_STORE_SETTING_ADD, data)
}
export const ORG_STORE_SETTING_ROLES = "Store/StoreSettings/Get/"
export function getOrgStoreSettingRoles(id: any) {
  return axios.get(ORG_STORE_SETTING_ROLES + id + "/",)
}
export const ORG_STORE_SETTING_UPDATE = "Store/StoreSettings/Update/"
export function PatchOrgStoreSettingUpdate(id: any, data: any) {
  return axios.patch(ORG_STORE_SETTING_UPDATE + id + "/", data)
}

// Branch Setting


export const ORG_BRANCH_SETTING_LIST = "Store/BranchSettings/List/"
export function getOrgBranchSettingList() {
  return axios.get(ORG_BRANCH_SETTING_LIST)
}
export const ORG_BRANCH_SETTING_ADD = "Store/BranchSettings/Add/"
export function postBranchSettingRoleAdd(data: any) {
  return axios.post(ORG_BRANCH_SETTING_ADD, data)
}
export const ORG_BRANCH_SETTING_ROLES = "Store/BranchSettings/Get/"
export function getOrgBranchSettingRoles(id: any) {
  return axios.get(ORG_BRANCH_SETTING_ROLES + id + "/")
}
export const ORG_BRANCH_SETTING_UPDATE = "Store/BranchSettings/Update/"
export function PatchOrgBranchSettingUpdate(id: any, data: any) {
  return axios.patch(ORG_BRANCH_SETTING_UPDATE + id + "/", data)
}
// media added 
export const STORE_OFFER_MEDIA_LIST_GALLARYKEY_TYPES = "/Store/Offer/Media/ListGalleryKeyTypes/"
export function getStoreMediaListGalleryKeyTypes() {
  return axios.get(STORE_OFFER_MEDIA_LIST_GALLARYKEY_TYPES);
}
export const ORG_TREE_NODE_MEDIA_ADD = "/Org/Tree/NodeMedia/Add/";
export const ORG_TREE_NODE_MEDIA_LIST = "/Org/Tree/NodeMedia/List/";

export const ORG_TREE_NODE_MEDIA_REMOVE = "/Org/Tree/NodeMedia/Remove/";
export function deleteOrgNodeMedia(id: any) {
  return axios.delete(ORG_TREE_NODE_MEDIA_REMOVE + id + "/");
}

//  servie day 

export const ORG_SERVICES_BUSINESSDAYS_LIST = "/Org/Services/BusinessDays/List/"
export const ORG_SERVICES_BUSINESSDAY_GET = "/Org/Services/BusinessDay/Get/"
export const ORG_SERVICES_BUSINESSDAYS_ADD = "/Org/Services/BusinessDays/Add/"
export const ORG_SERVICES_BUSINESSDAY_UPDATE = "/Org/Services/BusinessDay/Update/"
export const ORG_SERVICES_BUSINESSDAY_DELETE = "/Org/Services/BusinessDay/Remove/"

export function getOrgServicesBusinessdysList() {
  return axios.get(ORG_SERVICES_BUSINESSDAYS_LIST)
}
export function postOrgServicesBusinessdysAdd(data: any) {
  return axios.post(ORG_SERVICES_BUSINESSDAYS_ADD, data)
}
export function getOrgServicesBusinessdysGet(id: any) {
  return axios.get(ORG_SERVICES_BUSINESSDAY_GET + id + "/")
}
export function patchOrgServicesBusinessdysUpdate(id: any, data: any) {
  return axios.patch(ORG_SERVICES_BUSINESSDAY_UPDATE + id + "/", data)
}
export function deleteOrgServicesBusinessdysRemove(id: any) {
  return axios.delete(ORG_SERVICES_BUSINESSDAY_DELETE + id + "/")
}

// service hours 

export const ORG_SERVICES_BUSINESS_HOURS_LIST = "/Org/Services/BusinessHours/List/"
export const ORG_SERVICE_BUSINESS_HOURS_GET = "/Org/Services/BusinessHours/Get/"
export const ORG_SERVICE_BUSINESS_HOURS_ADD = "/Org/Services/BusinessHours/Add/"
export const ORG_SERVICES_BUSINESS_HOURS_UPDATE = "/Org/Services/BusinessHours/Update/"
export const ORG_SERVICE_BUSINESS_HOURS_ROMOVE = "/Org/Services/BusinessHours/Remove/"


export function getOrgServicesBusinessHoursList() {
  return axios.get(ORG_SERVICES_BUSINESS_HOURS_LIST)
}
export function postOrgServicesBusinessHoursAdd(data: any) {
  return axios.post(ORG_SERVICE_BUSINESS_HOURS_ADD, data)
}
export function getOrgServicesBusinessHoursGet(id: any) {
  return axios.get(ORG_SERVICE_BUSINESS_HOURS_GET + id + "/")
}
export function patchOrgServicesBusinessHoursUpdate(id: any, data: any) {
  return axios.patch(ORG_SERVICES_BUSINESS_HOURS_UPDATE + id + "/", data)
}
export function deleteOrgServicesBusinessHoursRemove(id: any) {
  return axios.delete(ORG_SERVICE_BUSINESS_HOURS_ROMOVE + id + "/")
}

// roles Api 

export const ORG_SERVICES_SERVICEINSTANCE_LIST =
  "Org/Services/ServiceInstances/List/";

export function gerServiceInstanceList() {
  return axios.get(ORG_SERVICES_SERVICEINSTANCE_LIST);
}
export const ORG_ROLES_GROUP_ADD = "/Org/Roles/Group/Add/"
export function postRoleGroupAdd(data: any) {
  return axios.post(
    ORG_ROLES_GROUP_ADD, data
  );
}
export const ORG_ROL_GROUP_LIST = "Org/Roles/Group/List/"
export function getOrgRolesList(id: any) {
  return axios.get(ORG_ROL_GROUP_LIST + "?org_instance=" + id)
}
export const ORG_EDIT_ROLES_GET = "/Org/Roles/Group/Get/"
export function getOrgEditRoles(id: any) {
  return axios.get(ORG_EDIT_ROLES_GET + id + "/")
}
export const ORG_ROLES_UPDATE = "Org/Roles/Group/Update/"
export function PatchOrgRolesUpdate(id: any, data: any) {
  return axios.patch(ORG_ROLES_UPDATE + id + "/", data)
}
export const ORG_ROLES_GROUP_REMOVE = "/Org/Roles/Group/Remove/"
export function deleteRolesGroupList(id: any) {
  return axios.delete(ORG_ROLES_GROUP_REMOVE + id + "/",)
}
// role 
export const ORG_ROLE_LIST = "Org/Roles/List/"
export function getOrgRolesAllList(id: any) {
  return axios.get(ORG_ROLE_LIST + "?service_instance_id=" + id)
}
export const ORG_ROLE_ADD = "/Org/Roles/Add/"
export function postRoleAdd(data: any) {
  return axios.post(ORG_ROLE_ADD, data)
}
export const ORG_EDIT_ROLES = "Org/Roles/GetRoleDetails/"
export function getOrgRole(id: any) {
  return axios.get(ORG_EDIT_ROLES + id + "/")
}
export const ORG_ROLES_REMOVE = "/Org/Roles/Remove/"
export function deleteRolesList(id: any) {
  return axios.delete(ORG_ROLES_REMOVE + id + "/",)
}
export const ORG_ROLE_ONE_UPDATE = "/Org/Roles/Update/"
export function PatchOrgRoleOneUpdate(id: any, data: any) {
  return axios.patch(ORG_ROLE_ONE_UPDATE + id + "/", data)
}
// Assign Role
export const ORG_USER_EMPLOYEE_LIST = "Org/User/EmployeeDetail/List/"
export function getOrgEmployeeList() {
  return axios.get(ORG_USER_EMPLOYEE_LIST)
}
// post Add 
export const ORG_ASSIGN_ROLE_ADD = "/Org/Posts/Add/"
export function postAssignRoleAdd(data: any) {
  return axios.post(ORG_ASSIGN_ROLE_ADD, data)
}
export const ORG_POSTS_LIST = "Org/Posts/List/"
export function getOrgPostsList() {
  return axios.get(ORG_POSTS_LIST)
}
export const ORG_GET_ASSIGN_ROLES = "Org/Posts/Get/"
export function getOrgAssignRoles(id: any) {
  return axios.get(ORG_GET_ASSIGN_ROLES + id + "/")
}
export const ORG_ROLES_ASSIGN_UPDATE = "/Org/Posts/Update/"
export function PatchOrgAssignUpdate(id: any, data: any) {
  return axios.patch(ORG_ROLES_ASSIGN_UPDATE + id + "/", data)
}
export const ORG_ASSIGN_ROLES_REMOVE = "Org/Posts/Remove/"
export function deleteAssignRolesList(id: any) {
  return axios.delete(ORG_ASSIGN_ROLES_REMOVE + id + "/",)
}

export const ORG_ROLES_REMOVE_VALUE = "/Org/Roles/Remove/";
export function deleteRole(id: any) {
  return axios.create(defaultOptions).delete(ORG_ROLES_REMOVE_VALUE + id + "/");
}

// Admin-user api
export const ORG_USER_GET_USER_DETAIL = "/Org/User/GetUserDetail/";
export function getAllUserList(id: any, deliverySystem:any, serveid?: any) {
  let url = ORG_USER_GET_USER_DETAIL + "?user_id=" + id;

  if (deliverySystem === "3" && serveid) {
    url += "&org_instance=" + serveid;
  }

  return axios.get(url);
}

export const ORG_USER_GET_USER_DETAIL_LIST = "/Org/User/GetUserDetail/";
export function getUserNameList(id: any) {
  return axios.get(ORG_USER_GET_USER_DETAIL + "?user_id=" + id);
}
//Brand
export const BRAND_LIST = "/Store/Product/Brand/List/";
export const BRAND_ADD = "/Store/Product/Brand/Add/"
export const BRAND_GET = "/Store/Product/Brand/Get/"
export const BRAND_UPDATE = "/Store/Product/Brand/Update/"
export const BRAND_DELETE = "/Store/Product/Brand/Remove/"


export function getBrandList() {
  return axios.get(BRAND_LIST + "?page_size=1000")
}
export function postBrandAdd(data: any) {
  return axios.post(BRAND_ADD, data)
}
export function getBrandGet(id: any) {
  return axios.get(BRAND_GET + id + "/")
}
export function patchBrandUpdate(id: any, data: any) {
  return axios.patch(BRAND_UPDATE + id + "/", data)
}
export function deleteBrandRemove(id: any) {
  return axios.delete(BRAND_DELETE + id + "/")
}

export const ORG_USER_REMOVE = "/Org/User/Remove/";
export function deleteUsersList(id: any) {
  return axios.delete(ORG_USER_REMOVE + id + "/");
}

export const STORE_PRODUCT_BRAND_IMAGES_REMOVE = "/Store/Product/Brand/Images/Remove/"
export function patchStoreProductImagesRemove(id: any, data: any) {
  return axios.patch(STORE_PRODUCT_BRAND_IMAGES_REMOVE + id + "/", data)
}
export const ORG_USER_USER_DETAIL_LIST = "/Org/User/UserDetail/List/";

// clubcard Details
export const ORG_CLUBCARD_LIST = "Store/User/CreditsSpend/List"
// "Store/User/CreditsAcquired/List"
export function getOrgClubCardList() {
  return axios.get(ORG_CLUBCARD_LIST)
}
export const ORG_CARDDETAILS_LIST = "Store/User/ClubCardDetails/Get/"
export function getOrgCardDetailsList(id: any) {
  return axios.get(ORG_CARDDETAILS_LIST + id + "/")
}
// rights

export const ORG_FEATURE_LIST = "Org/Policy/Feature/GetDetails/"
export function getFeatureList() {
  return axios.get(ORG_FEATURE_LIST)
}

export const ORG_FEATURE_ADD = "Org/Policy/RolePermission/Add/"
export function postFeatureAdd(data: any) {
  return axios.post(ORG_FEATURE_ADD, data)
}
export const Vehicle_Make_ADD = "Store/Vehicle/Make/Add/"
export function vehicleMakeAdd(data: any) {
  return axios.post(Vehicle_Make_ADD, data)
}

export const vehicle_Make_LIST = "Store/Vehicle/Make/List/"
export function vehicleMakeList(page = 1, filters = {}) {
  return axios.get(vehicle_Make_LIST, {
    params: {
      page,
      ...filters,
    },
  });
}
export const vehicle_Make_LIST_Select = "Store/Vehicle/Make/List/?page_size=1000"
export function vehicleMakeListSelect(params: any) {
  return axios.get(vehicle_Make_LIST_Select, { params });
}
export const vehicle_Make_GET = "Store/Vehicle/Make/Get/"
export function vehicleMakeGet(data: any) {
  return axios.get(vehicle_Make_GET, data)
}
export const vehicle_Make_UPDATE = "/Store/Vehicle/Make/Update/"
export function vehicleMakeUpdate(id: any, data: any) {
  return axios.patch(vehicle_Make_UPDATE + id + "/", data)
}
export const vehicle_Make_REMOVE = "Store/Vehicle/Make/Remove/";
export function vehicleMakeRemove(id: any) {
  return axios.delete(vehicle_Make_REMOVE + id + "/");
}
export const Vehicle_Model_ADD = "Store/Vehicle/Model/Add/"
export function vehicleModelAdd(data: any) {
  return axios.post(Vehicle_Model_ADD, data)
}
export const Vehicle_Model_LIST = "Store/Vehicle/Model/List/"
export function vehicleModelList(page = 1, filters = {}) {
  return axios.get(Vehicle_Model_LIST, {
    params: {
      page,
      ...filters,
    },
  });
}
export const vehicle_Model_REMOVE = "Store/Vehicle/Model/Remove/";
export function vehicleModelRemove(id: any) {
  return axios.delete(vehicle_Model_REMOVE + id + "/");
}
export const vehicle_Model_GET = "Store/Vehicle/Model/Get/"
export function vehicleModeGet(data: any) {
  return axios.get(vehicle_Model_GET, data)
}
export const vehicle_Model_UPDATE = "Store/Vehicle/Model/Update/"
export function vehicleModelUpdate(id: any, data: any) {
  return axios.patch(vehicle_Model_UPDATE + id + "/", data)
}
export const OrderDriverStatus = "Store/Delivery/Order/Request/Status/List"
export const getOrderDriverStatus = (orderId:any) => {
  return axios.get(`${OrderDriverStatus}?order_id=${orderId}`);
};
export const Vendor_Invoice_List = "Store/Delivery/Vendor/Invoice/List/"
export function VendorInvoiceList(page = 1, filters = {}) {
  return axios.get(Vendor_Invoice_List, {
    params: {
      page,
      ...filters,
    },
  });
}
export const Vendor_Invoice_GET = "Store/Delivery/Vendor/Invoice/Get/"
export function vendorInvoiceGet(id: any) {
  return axios.get(Vendor_Invoice_GET+ "?id=" + id)
}
export const Vendor_Payment_ADD = "Store/Delivery/Vendor/Invoice/Payment/Add/"
export function vendorpaymentAdd(data: any) {
  return axios.post(Vendor_Payment_ADD, data)
}
export const Vendor_Payment_List = "Store/Delivery/Vendor/Invoice/Payment/List/"
export function VendorPaymentList(page = 1, filters = {}) {
  return axios.get(Vendor_Payment_List, {
    params: {
      page,
      ...filters,
    },
  });
}
export const Vendor_Payment_Delete = "Store/Delivery/Vendor/Invoice/Payment/Delete/"
export function VendorPaymentDelete(id: any) {
  return axios.delete(Vendor_Payment_Delete+ id + "/")
}
export const Statistics_List = "Statistics/Client/Dashboard/Order/Payments"
export function StatisticsList(
  page = 1,
  filters: any = {},
  extraParams: any = {}
) {
  return axios.get(Statistics_List, {
    params: {
      page,
      ...filters,
      ...extraParams,
    },
  });
}
export const OrderStats="Store/Admin/Orders/Stats/Count"
export function getOrderStats(id:any) {
  return axios.get(`${OrderStats}?instance_id=${id}`)
}
export const DriverLocationStatus = "Store/Delivery/Driver/Location/Status/List"
export const Driver_Auto_assign = "Store/Admin/Driver/Auto/Assign/"
export function driverAutoAssign(id: any) {
  return axios.post(Driver_Auto_assign+ id+"/")
}
export const Driver_Manual_assign = "Store/Admin/Driver/Manual/Assign/"
export function driverManualAssign(id: any,data:any) {
  return axios.post(Driver_Manual_assign+ id+"/",data)
}
export const Driver_Nearby_assign = "Store/Admin/Nearby/Driver/List/"
export function driverNearbyAssign(data:any) {
  return axios.get(Driver_Nearby_assign+"?order_id="+data?.order_id+"&org_instance="+data?.org_instance)
}
export const Driver_ADD = "Store/Driver/Add/"
export function DriverAdd(data: any) {
  return axios.post(Driver_ADD, data)
}
export const Driver_Trip_Detail = "Store/Delivery/Driver/Trip/Detail/List/"
export const Driver_List = "Store/Driver/List/"
export function DriverList(page = 1, filters = {}) {
  return axios.get(Driver_List, {
    params: {
      page,
      ...filters,
    },
  });
}
export const Driver_Invoice_List = "Store/Delivery/Driver/Invoice/List/"
export function DriverInvoiceList(page = 1, filters = {}) {
  return axios.get(Driver_Invoice_List, {
    params: {
      page,
      ...filters,
    },
  });
}
export const Driver_Attendance_List = "Store/Delivery/Driver/Attendance/Stat/"
export function DriverAttendanceList(page = 1, filters = {}) {
  return axios.get(Driver_Attendance_List, {
    params: {
      page,
      ...filters,
    },
  });
}

export const Driver_Invoice_GET = "Store/Delivery/Driver/Invoice/Get/"
export function driverInvoiceGet(id: any) {
  return axios.get(Driver_Invoice_GET+ "?id=" + id)
}

export const Payment_ADD = "Store/Delivery/Driver/Invoice/Payment/Add/"
export function paymentAdd(data: any) {
  return axios.post(Payment_ADD, data)
}
export const Payment_List = "Store/Delivery/Driver/Invoice/Payment/List/"
export function PaymentList(page = 1, filters = {}) {
  return axios.get(Payment_List, {
    params: {
      page,
      ...filters,
    },
  });
}
export const payment_REMOVE = "Store/Delivery/Driver/Invoice/Payment/Delete/";
export function paymentRemove(id: any) {
  return axios.delete(payment_REMOVE + id + "/");
}

export const Package_Fee_ADD = "Store/Package/Fee/Add/"
export function PackagefeeeAdd(data: any) {
  return axios.post(Package_Fee_ADD, data)
}
export const Package_Fee_UPDATE = "Store/Package/Fee/Update/"
export function PackageFeeUpdate(id: any, data: any) {
  return axios.patch(Package_Fee_UPDATE + id + "/", data)
}
export const Package_Fee_Get = "Store/Package/Fee/Get/"
export function PackageFeeGet(id: any) {
  return axios.get(Package_Fee_Get + "?id=" +id)
}
export const Platform_Fee_ADD = "Store/Platform/Fee/Rule/Add/"
export function PlatformfeeeAdd(data: any) {
  return axios.post(Platform_Fee_ADD, data)
}
export const Package_Fee_List = "Store/Package/Fee/List/"
export function PackageFeeList(page = 1, filters = {}) {
  return axios.get(Package_Fee_List, {
    params: {
      page,
      ...filters,
    },
  });
}
export const Package_Fee_REMOVE = "Store/Package/Fee/Remove/"
export function PackageFeeRemove(id: any) {
  return axios.delete(Package_Fee_REMOVE + id + "/");
}
export const Platform_Fee_UPDATE = "Store/Platform/Fee/Rule/Update/"
export function PlatformFeeUpdate(id: any, data: any) {
  return axios.patch(Platform_Fee_UPDATE + id + "/", data)
}
export const Platform_Fee_List = "Store/Platform/Fee/Rule/List/"
export function PlatformFeeList(page = 1, filters = {}) {
  return axios.get(Platform_Fee_List, {
    params: {
      page,
      ...filters,
    },
  });
}
export const Platform_Fee_Get = "Store/Platform/Fee/Rule/Get/"
export function PlatformFeeGet(id: any) {
  return axios.get(Platform_Fee_Get + "?id=" +id)
}
export const Platform_Fee_REMOVE = "Store/Platform/Fee/Rule/Remove/"
export function PlatformFeeRemove(id: any) {
  return axios.delete(Platform_Fee_REMOVE + id + "/");
}
export const Delivery_Fare_ADD = "Store/Delivery/Fee/Add/"
export function DeliveryFareAdd(data: any) {
  return axios.post(Delivery_Fare_ADD, data)
}
export const Delivery_Fare_List = "Store/Delivery/Fee/List/"
export function DeliveryList(page = 1, filters = {}) {
  return axios.get(Delivery_Fare_List, {
    params: {
      page,
      ...filters,
    },
  });
}
export const Delivery_Fare_REMOVE = "Store/Delivery/Fee/Remove/";
export function DeliveryFareRemove(id: any) {
  return axios.delete(Delivery_Fare_REMOVE + id + "/");
}
export const Delivery_Fare_UPDATE = "Store/Delivery/Fee/Update/"
export function DeliveryFareUpdate(id: any, data: any) {
  return axios.patch(Delivery_Fare_UPDATE + id + "/", data)
}
export const Delivery_Fare_Get = "Store/Delivery/Fee/Get/"
export function DeliveryFareGet(id: any) {
  return axios.get(Delivery_Fare_Get +"?id=" + id)
}
export const Driver_Get = "Store/Driver/Get/"
export function DriverGet(id: any) {
  return axios.get(Driver_Get + id + "/")
}
export const Driver_UPDATE = "Store/Driver/Update/"
export function driverUpdate(id: any, data: any) {
  return axios.patch(Driver_UPDATE + id + "/", data)
}
export const Driver_REMOVE = "Store/Driver/Remove/";
export function driverRemove(id: any) {
  return axios.delete(Driver_REMOVE + id + "/");
}
export const Driver_Profile_ADD = "Store/Driver/ProfileImg/Add/"
export function DriverProfileAdd(id: any, data: any) {
  return axios.post(`${Driver_Profile_ADD}?id=${id}`, data);
}
export const Driver_Bank_Get = "Store/Driver/Bank/Details/Get/"
export function DriverBankGet(id: any) {
  return axios.get(Driver_Bank_Get + id + "/")
}
export const Driver_Bank_ADD = "Store/Driver/Bank/Details/Add/"
export function DriverBankAdd(data: any) {
  return axios.post(Driver_Bank_ADD, data)
}
export const Driver_Bank_List = "Store/Driver/Bank/Details/List/"
export function DriverBankList(id: any) {
  return axios.get(Driver_Bank_List, {
    params: { driver: id }
  });
}
export const Driver_Bank_UPDATE = "Store/Driver/Bank/Details/Update/"
export function driverBankUpdate(id: any, data: any) {
  return axios.patch(Driver_Bank_UPDATE + id + "/", data)
}
export const Document_Section_List = "/Store/Driver/Document/Section/List/"
export function DocumentSectionList() {
  return axios.get(Document_Section_List)
}
export const Document_Add = "Store/Driver/Document/Add/"
export function DocumentAdd(data: any) {
  return axios.post(Document_Add, data)
}
export const Document_Get = "Store/Driver/Document/Get/"
export function DocumentGet(id: any) {
  return axios.get(Document_Get + id + "/")
}
export const Document_List = "/Store/Driver/Document/List/"
export function DocumentList(id: any) {
  return axios.get(Document_List, {
    params: { driver: id }
  });
}
export const Document_UPDATE = "Store/Driver/Document/Update/"
export function documentUpdate(id: any, data: any) {
  return axios.patch(Document_UPDATE + id + "/", data)
}
export const vehicle_Type_ADD = "Store/Vehicle/Type/Add/"
export function vehicleTypeAdd(data: any) {
  return axios.post(vehicle_Type_ADD, data)
}
export const vehicle_Type_List = "Store/Vehicle/Type/List/"
export function vehicle_TypeList(page = 1, filters = {}) {
  return axios.get(vehicle_Type_List, {
    params: {
      page,
      ...filters,
    },
  });
}
export const vehicle_Type_REMOVE = "Store/Vehicle/Type/Remove/";
export function vehicleTypeRemove(id: any) {
  return axios.delete(vehicle_Type_REMOVE + id + "/");
}
export const vehicle_Type_Get = "Store/Vehicle/Type/Get/"
export function vehicleTypeGet(id: any) {
  return axios.get(vehicle_Type_Get + "?id=" + id)
}
export const vehicle_Type_UPDATE = "Store/Vehicle/Type/Update/"
export function vehicleTypeUpdate(id: any, data: any) {
  return axios.patch(vehicle_Type_UPDATE + id + "/", data)
}
export const vehicle_ADD = "Store/Vehicle/Add/"
export function vehicleAdd(data: any) {
  return axios.post(vehicle_ADD, data)
}
export const vehicle_LIST = "/Store/Vehicle/List/"
export function vehicleList(id: any) {
  return axios.get(vehicle_LIST, {
    params: { driver_id: id }
  });
}
export const vehicle_REMOVE = "/Store/Vehicle/Remove/";
export function vehicleRemove(id: any) {
  return axios.delete(vehicle_REMOVE + id + "/");
}
export const vehicle_Get = "Store/Vehicle/Get/"
export function vehicleGet(id: any) {
  return axios.get(vehicle_Get + "?id=" + id)
}
export const vehicle_UPDATE = "Store/Vehicle/Update/"
export function vehicleUpdate(id: any, data: any) {
  return axios.patch(vehicle_UPDATE + id + "/", data)
}
export const Delivery_Location_ADD = "Store/Delivery/Location/Add/"
export function deliveryLocationAdd(data: any) {
  return axios.post(Delivery_Location_ADD, data)
}
export const Delivery_Location_LIST = "Store/Delivery/Location/List/"
export function deliveryLocationList(page = 1, filters = {}) {
  return axios.get(Delivery_Location_LIST, {
    params: {
      page,
      ...filters,
    },
  })
}
export const Delivery_Location_REMOVE = "Store/Delivery/Location/Remove/";
export function deliveryLocationRemove(id: any) {
  return axios.delete(Delivery_Location_REMOVE + id + "/");
}
export const Delivery_Location_Get = "Store/Delivery/Location/Get/"
export function deliveryLocationGet(id: any) {
  return axios.get(Delivery_Location_Get + "?id=" + id)
}
export const Delivery_Location_UPDATE = "/Store/Delivery/Location/Update/"
export function deliverylocationUpdate(id: any, data: any) {
  return axios.patch(Delivery_Location_UPDATE + id + "/", data)
}
export const Fare_ADD = "Store/Fare/Add/"
export function FareAdd(data: any) {
  return axios.post(Fare_ADD, data)
}
export const Fare_List = "Store/Fare/List/"
export function FareList() {
  return axios.get(Fare_List)
}
export const Fare_Remove = "Store/Fare/Remove/"
export function FareRemove(id: any) {
  return axios.delete(Fare_Remove + id + "/");
}
export const Fare_Get = "Store/Fare/Get/"
export function FareGet(id: any) {
  return axios.get(Fare_Get + "?id=" + id)
}
export const Fare_UPDATE = "Store/Fare/Update/"
export function FareUpdate(id: any, data: any) {
  return axios.patch(Fare_UPDATE + id + "/", data)
}
export const Delivery_Config_List = "Store/Delivery/Service/Config/List/"
export function DeliveryConfigList(service_instance: string) {
  return axios.get(Delivery_Config_List, {
    params: {
      service_instance: service_instance
    }
  });
}
export const Delivery_Prices_List = "Store/Order/Get/Delivery/Prices"
export function DeliveryPriceList(data: any) {
  return axios.post(Delivery_Prices_List, data);
}
export const DeliveryConfig_ADD = "Store/Delivery/Service/Config/Add/"
export function DeliveryConfigAdd(data: any) {
  return axios.post(DeliveryConfig_ADD, data)
}
export const Provider_List = "Store/Delivery/Provider/Choices/List/"
export function ProviderList() {
  return axios.get(Provider_List)
}
export const DeliveryConfig_Remove = "Store/Delivery/Service/Config/Remove/"
export function DeliveryConfigRemove(id: any) {
  return axios.delete(DeliveryConfig_Remove + id + "/");
}
export const Delivery_Config_UPDATE = "Store/Delivery/Service/Config/Update/"
export function DeliveryConfigUpdate(id: any, data: any) {
  return axios.patch(Delivery_Config_UPDATE + id + "/", data)
}
export const Delivery_Config_Get = "Store/Delivery/Service/Config/Get/"
export function DeliveryConfigGet(id: any) {
  return axios.get(Delivery_Config_Get + "?id=" + id)
}
export const DeliveryExternal_Remove = "Store/Order/Cancel/External/Delivery/"
export function DeliveryExternalRemove(data: any) {
  return axios.post(DeliveryExternal_Remove,data);
}
export const DeliveryExternal_Create = "Store/Order/Create/External/Delivery/"
export function DeliveryExternalCreate(data: any) {
  return axios.post(DeliveryExternal_Create,data);
}
export const privacy_policy = "Org/Public/Services/ServiceInstances/List/"
export const Meta_marketing_config_list = "Store/Meta/Marketing/Config/List/"

export const Meta_marketing_config_add = "Store/Meta/Marketing/Config/Add/"
export function Metamarketingconfigadd(data: any) {
  return axios.post(Meta_marketing_config_add, data)
}
export const Meta_marketing_config_update = "Store/Meta/Marketing/Config/Update/"
export function Metamarketingconfigupdate(id: any, data: any) {
  return axios.patch(Meta_marketing_config_update + id + "/", data)
}
export const Meta_marketing_config_get = "Store/Meta/Marketing/Config/Get/"
export function Metamarketingconfigget(id: any) {
  return axios.get(Meta_marketing_config_get + "?id=" + id)
}
export const Meta_marketing_config_remove = "Store/Meta/Marketing/Config/Remove/"
export function Metamarketingconfigremove(id: any) {
  return axios.delete(Meta_marketing_config_remove + id + "/");
}
export const Meta_Catalogue_Upload_Products = "meta/catalogue/upload/products/"
export const Meta_Catalogue_Create = "meta/catalogue/create/"
export const Meta_Catalogue_Status = "meta/catalogue/status/"
export const Meta_Catalogue_Upload_Bulk = "meta/catalogue/upload/bulk/"
export const Meta_Catalogue_Unsynced_Products =
  "meta/catalogue/products/unsynced/";
export const Meta_Catalogue_Remove_Products = "meta/catalogue/remove/products/";
export const Meta_Catalogue_List = "meta/catalogue/list/";
export const Voucher_List = "Store/Pos/Voucher/Config/List/";
export const Voucher_Remove = "Store/Pos/Voucher/Config/Remove/";
export function VoucherRemove(id: any) {
  return axios.delete(Voucher_Remove + id + "/");
}
export const Voucher_Add = "Store/Pos/Voucher/Config/Add/"
export function VoucherAdd(data: any) {
  return axios.post(Voucher_Add, data)
}